export const gridOptions = {
  computed: {
    gridOptions() {
      return {
        columnDefs: [
          {
            headerName: 'Name',
            field: 'name',
            editable: params => params.data.name !== 'Total Budgets',
            cellClassRules: {
              'editable-cell': params => params.data.name !== 'Total Budgets'
            },
            cellRenderer: params => {
              if (params.value === 'Total Budgets') {
                return `<b>Total Budgets</b>`
              }
              return params.value || 'N/A'
            },
            cellEditorFramework: 'TextEditor'
          },
          ...this.dynamicCols,
          {
            headerName: 'Actions',
            field: 'actions',
            sortable: false,
            lockVisible: true,
            maxWidth: 100,
            cellRendererFramework: 'ActionsCol',
            type: 'centerAligned',
            cellRendererParams: params => ({
              popupActions: [
                {
                  name: 'delete',
                  label: 'Delete',
                  textColorClass: 'text-danger-1'
                }
              ],
              onPopupAction: () => this.onDeleteDep(params),
              hide: params.data.name === 'Total Budgets' || params.data.system
            })
          }
        ],
        pinnedBottomRowData: this.bottomPinnedRow ? [this.bottomPinnedRow] : [],
        domLayout: 'autoHeight'
      }
    }
  }
}
